export const MISSING_I18N_TAG = 'i18n.missing' as const;
